import { inject, Injectable } from '@angular/core';
import { AccountService } from '@core/services/account';
import { environment } from '@environment/environment';
import { WorkflowStorageOwnerMissingError } from './workflow-storage.errors';
import type { WorkflowStorageOwner } from './workflow-storage.types';

/**
 * Текущий владелец записей регламентов: окружение + авторизованный пользователь.
 */
@Injectable({ providedIn: 'root' })
export class WorkflowStorageOwnerService {
  private readonly accountService = inject(AccountService);

  getOwner(): WorkflowStorageOwner | null {
    const userId = this.accountService.$currentUser()?.id;

    if (userId === undefined || userId === null) {
      return null;
    }

    return {
      environment: environment.xOutkeepInfrastructureEnv,
      userId,
    };
  }

  requireOwner(): WorkflowStorageOwner {
    const owner = this.getOwner();

    if (!owner) {
      throw new WorkflowStorageOwnerMissingError();
    }

    return owner;
  }
}
